import { Send } from "lucide-react";
import { Reveal } from "../Reveal";
import { Field } from "../quote/FormControls";
import { useContactForm } from "../../hooks/useContactForm";

export const ContactForm = () => {
  const { form, sending, set, submit } = useContactForm();
  return (
    <Reveal delay={0.15}>
      <form data-testid="contact-form" onSubmit={submit} className="bg-[#18181B] border border-white/10 rounded-3xl p-6 sm:p-10">
        <h3 className="font-display text-3xl font-extrabold uppercase tracking-wide mb-2">Send a message</h3>
        <p className="text-zinc-500 text-sm mb-8">We reply within one business day.</p>
        <div className="flex flex-col gap-5">
          <Field label="Name *">
            <input data-testid="contact-form-name" required value={form.name} onChange={set("name")} className="input-dark" placeholder="Your name" />
          </Field>
          <Field label="Email *">
            <input data-testid="contact-form-email" required type="email" value={form.email} onChange={set("email")} className="input-dark" placeholder="you@email.com" />
          </Field>
          <Field label="Message *">
            <textarea data-testid="contact-form-message" required rows={5} value={form.message} onChange={set("message")} className="input-dark resize-none" placeholder="How can we help?" />
          </Field>
          <button data-testid="contact-form-submit-button" type="submit" disabled={sending} className="btn-primary !py-4 text-sm disabled:opacity-60 disabled:hover:scale-100">
            {sending ? "SENDING..." : <>SEND MESSAGE <Send size={15} /></>}
          </button>
        </div>
      </form>
    </Reveal>
  );
};
